/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import moment from "moment";
import Form from "antd/es/form";
import Input from "antd/es/input";
// import Checkbox from "antd/es/checkbox";
import Button from "antd/es/button";
import http from "../utils/http";
import Terms from "./Terms";
import Wording from "./Wording";
import BkpmLogo from "../../src/assets/bkpm-logo-new.png";
import OssLogo from "../../src/assets/oss-logo-new.png";
import { Col, Modal, Row } from "antd";
import {
  ExclamationCircleFilled,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import useIsMobile from "../utils/useIsMobile";

export default function FormAuth({
  setLoading,
  setResponse,
  // onWait,
  platform,
  lat,
  long,
  queue,
}) {
  // const columns = [
  //   {
  //     title: (
  //       <div style={{ fontSize: "11px", textAlign: "center" }}>
  //         Tanggal Konsultasi
  //       </div>
  //     ),
  //     dataIndex: "name",
  //     key: "name",
  //     render: (_text, record) => {
  //       return (
  //         <h6
  //           style={{
  //             fontSize: "11px",
  //             margin: 0,
  //             textAlign: "center",
  //           }}
  //         >
  //           {record.name}
  //         </h6>
  //       );
  //     },
  //   },
  //   {
  //     title: (
  //       <div style={{ fontSize: "11px", textAlign: "center" }}>
  //         Jam Konsultasi
  //       </div>
  //     ),
  //     dataIndex: "start_time",
  //     key: "start_time",
  //     render: (_text, record) => {
  //       return (
  //         <div
  //           style={{
  //             display: "flex",
  //             justifyContent: "center",
  //             fontSize: "11px",
  //           }}
  //         >{`${moment(record.start_time, "HH:mm:ss").format(
  //           "HH:mm"
  //         )}WIB - ${moment(record.end_time, "HH:mm:ss").format(
  //           "HH:mm"
  //         )} WIB`}</div>
  //       );
  //     },
  //   },
  //   {
  //     title: (
  //       <div style={{ fontSize: "11px", textAlign: "center" }}>
  //         Ketersediaan
  //       </div>
  //     ),
  //     dataIndex: "status",
  //     key: "status",
  //     width: 90,
  //     render: (text) => (
  //       <Tag
  //         color={text === true ? "green" : "red"}
  //         style={{ display: "flex", justifyContent: "center" }}
  //       >
  //         {text === true ? "Tersedia" : "Tidak Tersedia"}
  //       </Tag>
  //     ),
  //   },
  // ];

  // const convert_date = moment(new Date()).format("YYYY-MM-DD");

  const [form] = Form.useForm();
  const [params, setParams] = React.useState({});
  const [canceledSessionModal, setCanceledSessionModal] = React.useState(false);
  // const [openDetail, setOpenDetail] = React.useState(false);
  // const [listAllSchedule, setListAllSchedule] = React.useState([]);
  const [selectedRow, setSelectedRow] = React.useState(null);
  const [detailSchedule, setDetailSchedule] = React.useState(null);
  // const [number, setNumber] = React.useState(null);
  const [openDropdown, setOpenDropdown] = React.useState(false);
  const isMobile = useIsMobile();

  // const loadListAllSchedule = () => {
  //     http.post(
  //         `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_TENANT}/listAllSchedule`
  //     )
  //         .then((res) => {
  //             const filteredData = res?.data?.filter(
  //                 (item) => item.status !== false
  //             );
  //             setListAllSchedule(filteredData);
  //         })
  //         .catch(() => {
  //             setLoading(false);
  //             notification.error({
  //                 message: "Validasi link gagal, coba lagi nanti.",
  //                 placement: "bottomRight",
  //                 duration: 5,
  //             });
  //         });
  // };

  // const generateToken = () => {
  //   const randomNum = Math.floor(Math.random() * (9 * (Math.pow(10, 6)))) + (Math.pow(10, 6));
  //   setNumber(randomNum);
  // }

  const onSubmit = (values) => {
    setParams(values);
    // setNext(true);
    onNext(values);
  };
  const onNext = (params) => {
    params.phone = `+62${params.phone}`;
    // params.email = `${(params.name).replace(/ /g, '.')}@mail.com`;
    // params.email = ``;
    params.platform = platform ? platform : "twilio";
    params.account = "videocall_bkpm";
    params.schedule_date = selectedRow?.schedule_date;
    params.schedule_id = selectedRow?.id;
    // params.schedule_name = selectedRow?.name;
    params.member_id = params?.email;
    params.template_id = 2;
    params.is_notification = true;

    if (parseInt(process.env.REACT_APP_USE_LOCATION) === 1) {
      params.location = {
        latitude: lat,
        longitude: long,
      };
    }
    setLoading(true);
    http
      .post(
        `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_TENANT}/requestQueue`,
        params
      )
      .then(async (res) => {
        if (res) {
          setLoading(false);
          if (res?.status === 201) {
            setResponse(res.data);
            http
              .get(
                `${process.env.REACT_APP_API_URL}/${
                  process.env.REACT_APP_TENANT
                }/queuePosition/${
                  res.data.room.uniqueName
                }?timestamp=${new Date().getMilliseconds()}`
              )
              .then(async (response) => {
                if (response) {
                  setLoading(false);
                  sessionStorage.setItem(
                    "isQueue",
                    JSON.stringify({
                      queue: response.data,
                      data: res.data,
                    })
                  );
                  setDetailSchedule({
                    queue: response.data,
                    data: res.data,
                  });
                }
              })
              .catch((err) => {
                setLoading(false);
              });
          }
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  // console.log(openDropdown);
  // const menu = (
  //     <div style={{ padding: 8, width: 400 }}>
  //         <Table
  //             columns={columns}
  //             dataSource={listAllSchedule}
  //             size="small"
  //             pagination={false}
  //             scroll={{ y: 240 }}
  //             onRow={(record) => ({
  //                 onClick: () => {
  //                     setSelectedRow(record); // Update state with selected row
  //                     setOpenDropdown(false);
  //                     // message.success(`Selected: ${record.name}`);
  //                 },
  //                 style: {
  //                     cursor: "pointer", // Add pointer cursor for better UX
  //                     fontSize: "10px",
  //                     backgroundColor:
  //                         selectedRow?.id === record.id ? "#e6f7ff" : "white", // Highlight selected row
  //                 },
  //             })}
  //         />
  //     </div>
  // );
  const endSession = () => {
    http
      .post(
        `${process.env.REACT_APP_API_URL}/${
          process.env.REACT_APP_TENANT
        }/cancel/${
          detailSchedule.data.room.uniqueName
        }?timestamp=${new Date().getMilliseconds()}`
      )
      .then(async (response) => {
        if (response) {
          setCanceledSessionModal(false);
          window.location.href = process.env.REACT_APP_BASE_URL;
          sessionStorage.removeItem("isQueue");
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  React.useEffect(() => {
    const checkQueue = sessionStorage.getItem("isQueue");
    if (checkQueue) {
      try {
        const data = JSON.parse(checkQueue);
        setDetailSchedule(data);
        http
          .get(
            `${process.env.REACT_APP_API_URL}/${
              process.env.REACT_APP_TENANT
            }/queuePosition/${
              data.data.room.uniqueName
            }?timestamp=${new Date().getMilliseconds()}`
          )
          .then(async (response) => {
            if (response) {
              setLoading(false);
              sessionStorage.setItem(
                "isQueue",
                JSON.stringify({
                  queue: response.data,
                  data: data.data,
                })
              );
              setDetailSchedule({
                queue: response.data,
                data: data.data,
              });
              setResponse(data.data);
            }
          })
          .catch((err) => {
            setLoading(false);
          });
      } catch (error) {}
    }
  }, []);

  React.useEffect(() => {
    if (queue) {
      try {
        const data = detailSchedule.data;
        setDetailSchedule({
          queue: queue,
          data: data,
        });
      } catch (error) {}
    }
  }, [queue]);

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (openDropdown && !event.target.closest(".ant-dropdown")) {
        setOpenDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openDropdown]);

  return (
    <>
      <div
        className="App"
        style={{
          height: isMobile ? "auto" : "100%",
        }}
      >
        {detailSchedule ? (
          <div className="App-Container">
            <div style={{ textAlign: "center" }}>
              <div
                style={{
                  display: "flex",
                  gap: 40,
                  alignItems: "center",
                  justifyContent: isMobile ? "space-around" : "center",
                  padding: !isMobile ? "0 1em 2em 2em" : "1rem 10px",
                }}
              >
                <div className="App-Image">
                  <img
                    src={BkpmLogo}
                    alt="Logo"
                    style={{
                      maxHeight: "100%",
                      maxWidth: "100%",
                    }}
                  />
                </div>
                <div className="App-Logo">
                  <img
                    src={OssLogo}
                    alt="Logo"
                    style={{
                      maxHeight: "100%",
                      maxWidth: "100%",
                    }}
                  />
                </div>
              </div>
              <h2
                style={{
                  textAlign: "center",
                  fontWeight: 600,
                  fontSize: "18px",
                  marginBottom: "16px",
                }}
              >
                Selamat datang di Layanan Video Call Kementerian Investasi dan
                Hilirisasi/BKPM
              </h2>

              {/* Antrian Info */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "40px",
                  marginBottom: "24px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  <p style={{ fontWeight: 500 }}>Antrian saat ini :</p>
                  <div
                    style={{
                      backgroundColor: "#b71d27",
                      color: "#fff",
                      fontSize: "32px",
                      fontWeight: "bold",
                      padding: "12px 24px",
                      borderRadius: "8px",
                      width: "fit-content",
                    }}
                  >
                    {detailSchedule ? detailSchedule?.queue?.inQueue : "-"}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  <p style={{ fontWeight: 500 }}>Nomor antrian Anda :</p>
                  <div
                    style={{
                      backgroundColor: "#004896",
                      color: "#fff",
                      fontSize: "32px",
                      fontWeight: "bold",
                      padding: "12px 24px",
                      borderRadius: "8px",
                      width: "fit-content",
                    }}
                  >
                    {detailSchedule
                      ? detailSchedule?.queue?.queuePosition
                      : "-"}
                  </div>
                </div>
              </div>

              {/* Tombol Batalkan */}
              <div style={{ textAlign: "center", marginBottom: "24px" }}>
                <Button
                  type="primary"
                  style={{ background: "#b71d27" }}
                  onClick={() => {
                    setCanceledSessionModal(true);
                  }}
                >
                  Batalkan Sesi
                </Button>
              </div>

              {/* Info tambahan */}
              <p
                style={{
                  textAlign: "center",
                  color: "#374151",
                  marginBottom: "16px",
                }}
              >
                Bapak/Ibu yang kami hormati, petugas kami akan segera melayani
                Anda. <br />
                Jangan menutup halaman ini. <br />
                Anda juga dapat berkonsultasi melalui layanan
              </p>

              <p
                style={{
                  textAlign: "center",
                  color: "#374151",
                  fontSize: "14px",
                  marginBottom: "24px",
                }}
              >
                <b style={{ fontWeight: "bold" }}>Whatsapp:</b> 08116774642
                &nbsp; | &nbsp;
                <b style={{ fontWeight: "bold" }}>Instagram:</b> @oss.go.id
                &nbsp; | &nbsp;
                <b style={{ fontWeight: "bold" }}>Email:</b> kontak@oss.go.id
                &nbsp; | &nbsp;
                <b style={{ fontWeight: "bold" }}>Call Center:</b> 169
              </p>

              {/* Footer Warning */}
              <div
                style={{
                  maxWidth: "70%",
                  backgroundColor: "#e0dcdc",
                  borderTop: "2px solid #dc2626",
                  padding: "16px",
                  borderRadius: "6px",
                  textAlign: "center",
                  fontSize: "13px",
                  margin: "0 auto",
                }}
              >
                <ExclamationCircleOutlined
                  style={{
                    fontSize: "20px",
                    color: "#b71d27",
                    marginRight: 10,
                  }}
                />{" "}
                Guna meningkatkan kualitas layanan, panggilan video ini akan
                direkam. Dilarang untuk merekam dan/atau menyebarluaskan audio
                dan gambar. Pelanggaran akan ditindak sesuai dengan peraturan
                perundang-undangan yang berlaku.
              </div>
            </div>
          </div>
        ) : (
          <div className="App-Container">
            <Row
              style={{
                width: isMobile ? "100%" : "",
                background: isMobile ? "#fff" : "",
              }}
              gutter={isMobile ? [0, 0] : [24, 16]}
            >
              <Col
                xs={{ span: 24 }}
                sm={{ span: 16 }}
                style={{ marginLeft: !isMobile ? "auto" : "" }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: 40,
                    alignItems: "center",
                    justifyContent: isMobile ? "space-around" : "",
                    padding: !isMobile ? "0 1em 2em 2em" : "1rem 10px",
                  }}
                >
                  <div className="App-Image">
                    <img
                      src={BkpmLogo}
                      alt="Logo"
                      style={{
                        maxHeight: "100%",
                        maxWidth: "100%",
                      }}
                    />
                  </div>
                  <div className="App-Logo">
                    <img
                      src={OssLogo}
                      alt="Logo"
                      style={{
                        maxHeight: "100%",
                        maxWidth: "100%",
                      }}
                    />
                  </div>
                </div>
              </Col>
            </Row>
            {isMobile ? <Wording /> : null}
            <Row gutter={[24, 16]}>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 8 }}
                md={{ span: 8 }}
                lg={{ span: 8 }}
                xl={{ span: 8 }}
              >
                <div className="App">
                  <div className="App-Card" style={{ padding: "2em" }}>
                    <div>
                      <h4
                        style={{
                          marginTop: 0,
                          fontWeight: 600,
                          textAlign: "center",
                        }}
                      >
                        Formulir Pendaftaran Konsultasi Video Call
                      </h4>
                      <Form
                        form={form}
                        name="basic"
                        layout="vertical"
                        onFinish={onSubmit}
                        onFinishFailed={(e) => console.log(e)}
                      >
                        <div
                          style={{
                            marginBottom: "6px",
                          }}
                        >
                          <Form.Item
                            label={
                              <h6
                                style={{
                                  margin: 0,
                                  fontSize: "12px",
                                }}
                              >
                                Nama lengkap{" "}
                                <span
                                  style={{
                                    color: "#BD1622",
                                  }}
                                >
                                  *
                                </span>
                              </h6>
                            }
                            name="name"
                            rules={[
                              {
                                // required: true,
                                message: "",
                              },
                            ]}
                            hasFeedback
                          >
                            <Input placeholder="Nama lengkap" />
                          </Form.Item>
                          <span
                            style={{
                              fontSize: "8px",
                              fontStyle: "italic",
                            }}
                          >
                            Wajib diisi
                          </span>
                        </div>
                        <div
                          style={{
                            marginBottom: "6px",
                          }}
                        >
                          <Form.Item
                            label={
                              <h6
                                style={{
                                  margin: 0,
                                  fontSize: "12px",
                                }}
                              >
                                Nomor ponsel{" "}
                                <span
                                  style={{
                                    color: "#BD1622",
                                  }}
                                >
                                  *
                                </span>
                              </h6>
                            }
                            name="phone"
                            rules={[
                              {
                                // required: true,
                                message: "",
                              },
                            ]}
                            hasFeedback
                          >
                            <Input
                              type="number"
                              prefix="+62"
                              placeholder="81x-xxxx-xxxx"
                            />
                          </Form.Item>
                          <span
                            style={{
                              fontSize: "8px",
                              fontStyle: "italic",
                            }}
                          >
                            Wajib diisi
                          </span>
                        </div>
                        <div
                          style={{
                            marginBottom: "6px",
                          }}
                        >
                          <Form.Item
                            label={
                              <h6
                                style={{
                                  margin: 0,
                                  fontSize: "12px",
                                }}
                              >
                                Email{" "}
                                <span
                                  style={{
                                    color: "#BD1622",
                                  }}
                                >
                                  *
                                </span>
                              </h6>
                            }
                            name="email"
                            rules={[
                              {
                                // required: true,
                                message: "",
                              },
                              {
                                type: "email",
                                message: "Email tidak valid",
                              },
                            ]}
                            hasFeedback
                          >
                            <Input placeholder="Email" />
                          </Form.Item>
                          <span
                            style={{
                              fontSize: "8px",
                              fontStyle: "italic",
                            }}
                          >
                            Wajib diisi
                          </span>
                        </div>
                        <div
                          style={{
                            marginBottom: "6px",
                          }}
                        >
                          <Form.Item
                            label="Nomor Induk Berusaha (opsional)"
                            name="nib"
                          >
                            <Input placeholder="1234567891011" type="number" />
                          </Form.Item>
                        </div>
                        <div
                          style={{
                            marginBottom: "6px",
                          }}
                        >
                          <Form.Item
                            label="Pertanyaan atau kendala"
                            name="pertanyaan"
                          >
                            <Input.TextArea
                              placeholder="NIB saya belum terbit..."
                              rows={2}
                            />
                          </Form.Item>
                        </div>
                        <Button
                          type="primary"
                          htmlType="submit"
                          block
                          shape="round"
                          // disabled={!selectedRow}
                        >
                          Kirim
                        </Button>
                      </Form>
                    </div>
                  </div>
                </div>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 16 }}
                md={{ span: 16 }}
                lg={{ span: 16 }}
                xl={{ span: 16 }}
              >
                {!isMobile ? <Wording /> : null}
                <Terms />
              </Col>
            </Row>
          </div>
        )}
      </div>

      <Modal
        title=""
        open={canceledSessionModal}
        footer={null}
        centered
        closable={false}
      >
        <div style={{ textAlign: "center" }}>
          {/* Icon */}
          <div style={{ marginBottom: "16px" }}>
            <ExclamationCircleFilled
              style={{ fontSize: "40px", color: "#b71d27" }}
            />
          </div>

          {/* Text */}
          <p
            style={{
              fontSize: "16px",
              fontWeight: 600,
              color: "#111827",
              marginBottom: "24px",
            }}
          >
            Apakah Anda yakin ingin membatalkan konsultasi ?
          </p>

          {/* Buttons */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              gap: "16px",
            }}
          >
            <Button
              onClick={() => setCanceledSessionModal(false)}
              style={{
                backgroundColor: "#b71d27",
                color: "#fff",
                fontWeight: 600,
                padding: "0 24px",
                border: "none",
              }}
              size="large"
            >
              Tidak
            </Button>
            <Button
              onClick={() => {
                endSession();
              }}
              style={{
                backgroundColor: "#004896",
                color: "#fff",
                fontWeight: 600,
                padding: "0 32px",
                border: "none",
              }}
              size="large"
            >
              Ya
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
